import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-part5',
  templateUrl: './part5.component.html',
  styleUrls: ['./part5.component.scss']
})
export class Part5Component implements OnInit {
  currentIndex = 0;
  readonly lstSideNav = [{
    text: `פעילות לעובדים<br />וגיבוש צוות`
    , color: '#FFFF00'
  },
  {
    text: `פעילות קהילתית<br />לציבור הרחב`
    , color: '#EC008C'
  },
  {
    text: `פעילות חברתית <br />משותפת לקבוצות`
    , color: '#33E8FF'
  }];
  readonly lstImages = ['jerusalem_municipality_logo.png', 'hidabrut_logo.png', 'netanya_logo.png'];

  lstWindows = [
    {
      firstText: `מתאים ל: חברות ארגונים, עיריות, בתי ספר ומוסדות<br />המעוניינים לגבש יחד את כל העובדים, לשעה משותפת.`
      , colorfullHeader: `איך מגבשים צוות<br />במשחק וירטואלי?`
      , secondText: `מכינים את הטריוויה המתאימה לאירוע שלכם, <br />
    מסכמים על שעה בה מתחילים.<br />
    נכנסים לאתר בקוד משחק יחודי, או מתקשרים למס’ טלפון<br />
    צופים, מאזינים ומתחרים!`
      , lstRowBox: [
        [
          {
            text: 'הרמת כוסית',
            imgUrl: 'glass-cheers.png'
          },
          {
            text: 'כנס העשרה',
            imgUrl: 'screen.png'
          },
          {
            text: 'פגישת מורל',
            imgUrl: 'hand-peace.png'
          }
        ],
        [
          {
            text: 'מפגש היכרות',
            imgUrl: 'smile.png'
          },
          {
            text: 'חגיגת השקה',
            imgUrl: 'confetti-ball.png'
          },
          {
            text: 'ימי הכנה',
            imgUrl: 'date.png'
          }
        ]
      ]
    },
    {
      firstText: `מתאים ל: חברות, ארגונים גדולים, עיריות<br/>המפיקים אירוע או פעילות לקהל הרחב`
      , colorfullHeader: `אילו פעילויות<br/>משחקים באונליין?`
      , secondText: `מכינים את הטריוויה המתאימה לאירוע שלכם,<br/>
      מסכמים על שעה בה מתחילים.  <br/>    
      נכנסים לאתר בקוד משחק יחודי, או מתקשרים למס’ טלפון  <br/>    
      צופים, מאזינים ומתחרים!`
      , lstRowBox: [
        [
          {
            text: 'חידונים',
            imgUrl: 'question.png'
          },
          {
            text: 'תחרות כשרון',
            imgUrl: 'podium.png'
          },
          {
            text: 'מופע מוזיקה',
            imgUrl: 'microfone.png'
          }
        ],
        [
          {
            text: 'משחק חוויתי',
            imgUrl: 'game.png'
          },
          {
            text: 'סקרים',
            imgUrl: 'note-book.png'
          },
          {
            text: 'סיור מודרך',
            imgUrl: 'hand.png'
          }
        ]
      ]
    },
    {
      firstText: `מתאים ל: בתי ספר, מוסדות, משפחות, קבוצות שונות<br />המארגנים אירוע או פעילות גיבוש פרטית`
      , colorfullHeader: `איך זה אפשרי<br />לשחק יחד כולם?`
      , secondText: `מכינים את השאלות בהתאמה לאירוע שלכם,<br />
      מסכמים את השעה בה כולם נפגשים.    <br />  
      בוחרים את הפורמט (אינטרנטי/טלפוני/אירוע מרחוק)  <br />    
      ומשחקים וירטואלית כולם בבת אחת מכל מקום!`
      , lstRowBox: [
        [
          {
            text: 'מחנה וקעמפ',
            imgUrl: 'tent.png'
          },
          {
            text: 'יום גיבוש',
            imgUrl: 'bus.png'
          },
          {
            text: 'כנס או פגישה',
            imgUrl: 'men.png'
          }
        ],
        [
          {
            text: 'בר/ת מצוה',
            imgUrl: 'cupcake.png'
          },
          {
            text: 'יומולדת',
            imgUrl: 'cake.png'
          },
          {
            text: 'מסיבה',
            imgUrl: 'party.png'
          }
        ]
      ]
    }
  ]
  readonly baseURL = './assets/images/part5/';
  constructor() { }

  ngOnInit(): void {
  }

}
